import React, { useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import InlineAccountTokenInfo from "./InlineAccountTokenInfo";
import DepositInteractionModal from "../InteractionModal/DepositInteractionModal";
import { useTokenIcon } from "../../hooks/useUrlGenerator";
import DisabledButtonHelper from "../DisabledButtonHelper";
import WithdrawInteractionModal from "../InteractionModal/WithdrawInteractionModal";
import useGenericCall from "../../hooks/useGenericCall";
import { useOnchainAccountPoolToken } from "../../hooks/useOnchain";


export default function AccountLendingPoolSupplyRow() {
  const data = useGenericCall(useOnchainAccountPoolToken(), async onchainAccountPoolToken => ({
    symbol: await (await onchainAccountPoolToken.getPoolToken().getOffchainPoolToken()).getSymbol(),
    deposited: await onchainAccountPoolToken.getDeposited(),
    depositedUSD: await onchainAccountPoolToken.getDepositedUSD(),
    maxWithdrawable: await onchainAccountPoolToken.getMaxWithdrawable(),
  }));
  const tokenIcon = useTokenIcon();

  const [showDepositModal, toggleDepositModal] = useState(false);
  const [showWithdrawModal, toggleWithdrawModal] = useState(false);

  if (!data) return (null);

  const withdrawDisabledInfo = `You haven't supplied any ${data.symbol} yet.`;

  return (<>
    <Row className="account-lending-pool-row">
      <Col md={3}>
        <Row className="account-lending-pool-name-icon">
          <Col className="token-icon">
            <img className='' src={tokenIcon} />
          </Col>
          <Col className="token-name">
            { `${data.symbol}` }
          </Col>
        </Row>
      </Col>
      <Col md={4} className="inline-account-token-info-container">
        <InlineAccountTokenInfo
          name="Supplied"
          symbol={data.symbol}
          value={data.deposited}
          valueUSD={data.depositedUSD}
        />
      </Col>
      <Col md={5} className="btn-table">
        <Row>
          <Col>
            <Button variant="primary" onClick={() => toggleDepositModal(true)}>Supply</Button>
          </Col>
          <Col>
            { data.maxWithdrawable > 0 ? (
              <Button variant="primary" onClick={() => toggleWithdrawModal(true)}>Withdraw</Button>
            ) : (
              <DisabledButtonHelper text={withdrawDisabledInfo}>Withdraw</DisabledButtonHelper>
            ) }
          </Col>
        </Row>
      </Col>
    </Row>
    <DepositInteractionModal 
      show={showDepositModal} 
      toggleShow={toggleDepositModal}
    />
    <WithdrawInteractionModal 
      show={showWithdrawModal} 
      toggleShow={toggleWithdrawModal}
    />
  </>);
}